import { Notification } from '@/types/notification'
import { formatDistanceToNow } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import {
    CheckCircle,
    XCircle,
    Bell,
    CreditCard,
    Users,
    Info,
    Clock,
    MessageSquare
} from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'

interface NotificationItemProps {
    notification: Notification
    onMarkAsRead: (id: string) => void
}

export default function NotificationItem({ notification, onMarkAsRead }: NotificationItemProps) {
    const iconMap = {
        booking_approved: CheckCircle,
        booking_rejected: XCircle,
        booking_reminder: Bell,
        payment_confirmed: CreditCard,
        payment_rejected: XCircle,
        new_member: Users,
        new_booking_request: Clock,
        system: Info,
        ADMIN_MESSAGE: Info,
        new_message: MessageSquare // Adicionado
    }

    const colorMap = {
        booking_approved: 'text-green-500',
        booking_rejected: 'text-red-500',
        booking_reminder: 'text-blue-500',
        payment_confirmed: 'text-green-500',
        payment_rejected: 'text-red-500',
        new_member: 'text-purple-500',
        new_booking_request: 'text-orange-500',
        ADMIN_MESSAGE: 'text-primary',
        system: 'text-primary',
        new_message: 'text-[#d4a94d]' // Adicionado
    }

    const Icon = iconMap[notification.type] || Info
    const iconColor = colorMap[notification.type] || 'text-gray-500'

    const navigate = useNavigate()

    const handleClick = () => {
        if (!notification.read) {
            onMarkAsRead(notification.id)
        }

        // Se for mensagem de admin, redirecionar para histórico
        if (notification.type === 'ADMIN_MESSAGE' || notification.type === 'system' || notification.type === 'new_message') {
            navigate('/communication?tab=history')
        }
    }

    const content = (
        <div
            onClick={handleClick}
            className={`p-4 hover:bg-primary/5 transition-colors cursor-pointer border-l-4 ${notification.read ? 'border-transparent bg-white' : 'border-secondary bg-secondary/5'
                }`}
        >
            <div className="flex items-start gap-3">
                <Icon className={`w-5 h-5 ${iconColor} shrink-0 mt-0.5`} />
                <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-bold text-primary truncate">
                        {notification.title}
                    </h4>
                    <p className="text-xs text-primary/70 mt-1 line-clamp-2">
                        {notification.message}
                    </p>
                    <span className="text-[10px] text-primary/50 mt-2 block">
                        {formatDistanceToNow(notification.createdAt.toDate(), {
                            addSuffix: true,
                            locale: ptBR
                        })}
                    </span>
                </div>
                {!notification.read && (
                    <div className="w-2 h-2 bg-secondary rounded-full shrink-0 mt-2"></div>
                )}
            </div>
        </div>
    )

    if (notification.actionUrl) {
        return (
            <Link to={notification.actionUrl} className="block">
                {content}
            </Link>
        )
    }

    return content
}
